export default "__VITE_ASSET__c632d2ac__"